<template>
  <button class="filter-btn w-100 border" :class="{ 'k-orange-linear': element.active }" @click="toggleBtn" v-ripple>
    <v-icon small :class="{ 'white--text': element.active }">{{ element.icon }}</v-icon>
    <small :class="{ 'white--text': element.active }">
      <v-tooltip bottom v-if="!showQty">
        <span slot="activator">
          {{ element.text }}
        </span>
        <span>
          ({{ element.qty }})
        </span>
      </v-tooltip>
      <span v-else>{{ element.text }}</span>
      <span v-if="showQty && element.qty !== undefined">
        ({{ element.qty }})
      </span>
    </small>
  </button>
</template>
<script>
export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
    showQty: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleBtn() {
      this.element.active = !this.element.active;
    },
  },
};
</script>
<style scoped>
  .filter-btn {
    padding-top: .125em; 
    padding-bottom: .125em; 
  }
  .border {
    border: 1px solid #d3d3d3;
    border-radius: 4px;
  }
  .filter-btn:focus {
    outline: none;
  }
</style>





// WEBPACK FOOTER //
// src/components/chat_center_v2/FilterBtn.vue